{
  "baseLayout": {
    "backButton": "Back",
    "menuButton": "Menu"
  },
  "reporting": {
    "selectReportButton": "Select Report",
    "viewBookingButton": "View Booking"
  },
  "bookingButtons": {
    "addFavJourneyButton": "Add Favourite Journey",
    "clearFavJourneyButton": "Clear Favourite Journey",
    "editBookingButton": "Edit Booking",
    "shareBookingButton": "Share Booking",
    "sendConfirmationButton": "Send Confirmation",
    "copyBookingButton": "Copy Booking",
    "returnBookingButton": "Return Booking",
    "cancelBookingButton": "Cancel Booking",
    "addToCalendarButton": "Add Booking to Calendar",
    "moreActionsButton": "More Booking Actions"
  },
  "newBooking": {
    "favJourneyCard": "Book Favourite Journey",
    "recentJourneyCard": "Book Recent Journey",
    "favJourneyEdit": "Edit Favourite Journey Description",
    "favJourneyClear": "Clear Favourite Journey",
    "selectBookingTemplateButton": "Begin Booking"
  },
  "masquerading": {
    "changeContactButton": "Change Contact",
    "selectContactButton": "Select Contact",
    "clearContactButton": "Clear Contact"
  },
  "bookingForm": {
    "stops": {
      "editStopButton": "Edit Stop Address",
      "saveAddressButton": "Save Address to Profile",
      "removeStopButton": "Remove Stop",
      "reorderStops": "Reorder Stops",
      "selectFlightCard": "Select Flight",
      "removeFlightButton": "Remove Flight Details",
      "stopsInputAccordion": "See More Details",
      "mapSearchButton": "Map Search",
      "asDirectedButton": "As Directed",
      "clearSearchButton": "Clear Search",
      "selectAddressButton": "Select Address"
    },
    "tariffs": {
      "reverseSort": "Reverse Tariff Sort"
    }
  },
  "profile": {
    "cards": {
      "makeDefaultCardButton": "Make Default Card",
      "deleteCardButton": "Delete Card",
      "selectCard": "Select Card"
    },
    "addresses": {
      "addAddressButton": "Add New Address",
      "addressFilterButton": "Address Filter",
      "reorderAddresses": "Reorder Addresses"
    },
    "addContactLinkButton": "Add Contact Link"
  },
  "selectProfileCard": "Select Profile",
  "clearSelectionButton": "Clear Selection",
  "refreshChip": "Refresh Content",
  "passwordToggle": "Toggle Password Visibility",
  "countryInputField": "Select Country / Region",
  "localeInput": "Select Language",
  "viewBooking": {
    "openDocument": "Open document"
  }
}
